import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    "& > .MuiInputBase-root": {
      paddingRight: 0,
    },
  },
}));
